import React, { useMemo } from 'react'

import Dropdown from '../../atoms/form/input/Dropdown'

interface Props {
  isCreatable?: boolean
  onChange: (selected: any) => void
  value?: number
  error?: string
  label?: string
  name?: string
  min: number
  max: number
  step?: number
  labelFormatter?: (val: number) => string
  formatCreateLabel?: (val: string) => string
  placeholder?: string
  small?: boolean
  blocklist?: number[]
  tiny?: boolean
}

function IntegerDropdown({
  onChange,
  value,
  error,
  label,
  name,
  min,
  max,
  step = 1,
  isCreatable=false,
  labelFormatter = (val) => `${val}`,
  formatCreateLabel = (val) => `${val}`,
  placeholder,
  small,
  blocklist = [],
  tiny
}: Props) {
  const options = useMemo(() => {
    const basicOptions = Array(((max - min) / step) + 1).fill(0).map((_, idx) => ({
      id: min + (idx * step),
      value: min + (idx * step),
      label: labelFormatter(min + (idx * step))
    }))

    if (value) {
      const current = basicOptions.find(item => item.value === value)

      if (!current) {
        basicOptions.push({
          id: value,
          label: labelFormatter(value),
          value: value,
        })
      }
    }

    return basicOptions.sort((a, b) => a.id - b.id).filter(option => option.value === value || !blocklist.includes(option.value))
  }, [max, min, step, value, labelFormatter, blocklist])

  const selectedValue = useMemo(() => {
    const selectedOption = options.find(option => option.value === value)

    return selectedOption || options[0]
  }, [options, value])

  return (
    <Dropdown
      isCreatable={isCreatable}
      data-test={name ?? 'integer-dropdown'}
      label={label}
      error={error}
      small={small}
      tiny={tiny}
      selectProps={{
        placeholder: placeholder,
        isClearable: isCreatable,
        options: options,
        value: selectedValue,
        onChange,
        formatCreateLabel,
        getNewOptionData: (val: string) => {
          const intValue = parseInt(val.replace(/[^\d]/g, ''))
          return {
            id: intValue,
            label: labelFormatter(intValue),
            value: intValue
          }
        },
        classNamePrefix: name ?? 'integer-dropdown'
      }}
    />
  )
}


export default IntegerDropdown
